module.exports = __webpack_public_path__ + "static/media/bank.e5765975.svg";